<template>
  <div style="padding:14px 10px">
    <div class="cur_route">{{$route.name}}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="conts fcl">
      <div class="frw fac">
        <div class="nav_item frw fac " :class="{nav_item_s:i==nav_index}" v-for="(item,i) in navs" :key="i"
          @click="navChange(i)">{{item}}
        </div>
      </div>
      <div class="div_cont box-sizing">
        <smsList v-if="nav_index==0" />
        <smsOperate v-if="nav_index==1" />
        <smsBackupsList v-if="nav_index==2" />
        <smsListAuxi v-if="nav_index==3" />
        <smsListOmit v-if="nav_index==4" />
        <smsListChecked v-if="nav_index==5" />
        <smsListGarbage v-if="nav_index==6" />
        <smsFile v-if="nav_index==7" />
      </div>
    </div>

  </div>
</template>
<script>
  import smsList from './sms_list.vue'
  import smsOperate from './sms_operate.vue'
  import smsBackupsList from './sms_backups_list.vue'
  import smsListAuxi from './sms_list_auxi.vue'
  import smsListOmit from './sms_list_omit.vue'
  import smsListChecked from './sms_list_checked.vue'
  import smsListGarbage from './sms_list_garbage.vue'
  import smsFile from './sms_file.vue'
  export default {
    components: {
      smsList,
      smsOperate,
      smsBackupsList,
      smsListAuxi,
      smsListOmit,
      smsListChecked,
      smsListGarbage,
      smsFile
    },
    data() {
      return {
        navs: ['SMS Lists', 'SMS Operations', 'SMS Backups', 'SMS Remaing', 'SMS Missing', 'SMS Garbage Pre',
          'SMS Garbage', 'SMS Files'
        ],
        nav_index: 0
      }
    },
    methods: {
      navChange(i) {
        this.nav_index = i
      }
    }
  }

</script>
<style scoped>
  .conts {
    margin-top: 20px;
  }

  .nav_item {
    height: 50px;
    padding: 0 22px;
    background: rgba(0, 184, 194, .05);
    border-radius: 16px 16px 0 0;
    color: rgba(11, 50, 117, .7);
    font-size: 14px;
    margin-right: 1px;
    border: 1px solid #fff;
    cursor: pointer;
  }

  .nav_item_s {
    color: #00b8c2;
    background: #fff;
    box-shadow: 5px 0 10px rgba(3, 97, 240, .12);
  }

</style>



// WEBPACK FOOTER //
// src/views/sms/sms.vue